module.exports = __webpack_public_path__ + "static/media/LP2.915bded2.jpg";